/**
 * Base64 to Hex Converter — Tool Manifest
 */
import type { ToolManifest } from "../../../lib/tool";

export const manifest: ToolManifest = {
  id: "base64-to-hex-converter",
  name: "Base64 to Hex Converter",
  description: "Bidirectional Base64 ↔ Hex conversion. Content-shape detection. UTF-8 safe.",
  category: "developer",
  keywords: ["base64 to hex converter", "base64 to hex converter", "encode", "decode", "converter"],
  icon: "Braces",
  requiresNetwork: false,
  seo: {
    title: "Base64 to Hex Converter — 100% Private, Offline | UnQTools",
    faq: [
      { q: "What does this tool do?", a: "Bidirectional Base64 ↔ Hex conversion. Content-shape detection. UTF-8 safe." },
      { q: "Is my data sent to a server?", a: "No. This tool runs 100% in your browser. Nothing is uploaded or tracked." },
      { q: "What extra features does this tool have?", a: "Extras: (1) Multiple modes/formats, (2) Live preview, (3) Import/export, (4) Bulk mode, (5) Copy/download, (6) History (localStorage), (7) Randomize, (8) Presets, (9) Validation, (10) PWA offline, (11) UTF-8 safe, (12) Dark mode." },
      { q: "Does this work offline?", a: "Yes — install as a PWA and use it without network." },
    ],
  },
  status: "planned",
};
